import React from 'react';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TText, TRecord, TTypeReference} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const SearchButton = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const formButtonClasses = classes.push('w-button');
    return <input {...generateAttributes(attributes, formButtonClasses)} />;
  }
);

const config = createDevlinkAtom({
  displayName: 'Search Button',
  constraints: {
    ancestors: [
      {
        is: ['SearchForm'],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  render: SearchButton,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord(
        {
          value: withMeta(
            {
              placeholder: 'e.g. Search',
            },
            withSystem(
              {
                label: 'Text',
                isLocalizable: true,
              },
              TText
            )
          ),
        },
        TTypeReference('extraAttrs')
      )
    ),
    search: withSystem({private: true}, TRecord({type: TText})),
  },
});

export default config;
